/* eslint-disable
    no-shadow,
    prefer-rest-params
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone, {ModelSaveOptions} from 'backbone';
import _ from 'underscore';

class BenchlingCollection<
  M extends Backbone.Model,
  MAttrs extends Backbone.ObjectHash,
> extends Backbone.Collection<M> {
  cid!: string;
  override url!: () => string;

  // For collections that are attributes of a model
  // that might be swapped out, with listenTo(model, change:collection)
  //
  // This is a result of backbone using _.isEqual
  // to determine if the change event should fire.
  // For example:
  //     _.isEqual(new Backbone.Collection(), new Backbone.Collection()) == true
  constructor(models?: Array<M> | Array<Partial<MAttrs>>, options?: Backbone.Parseable) {
    super(models, options);
    this.cid = _.uniqueId('collection_');
  }

  // Convenience function to add attributes / models to this collection, and notably returns a promise
  // instead of the added model.
  // On success, the promise resolves to the new model.
  // On failure, the model is removed from the collection.
  betterCreate(
    attrsOrModel: M | Partial<MAttrs>,
    // latter options are for backbone-extensions
    // TODO: Convert backbone-extensions to TS and make sure prototype overrides propagate
    options?: Backbone.ModelSaveOptions & {fileUpdate?: boolean}
  ): JQueryPromise<M> | false {
    const model = this.add(attrsOrModel);
    const res = model.save(null, options);
    if (!res) {
      // If validation failed, remove and return.
      this.remove(model);
      return res;
    }
    return res.fail(() => this.remove(model)).then(() => model);
  }

  bulkDelete(
    models: Array<M>,
    // latter options are for backbone-extensions
    // TODO: Convert backbone-extensions to TS and make sure prototype overrides propagate
    options?: Backbone.ModelDestroyOptions & {fileUpdate?: boolean}
  ): JQueryPromise<{message: string; deleted: number}> {
    const modelIds = (() => {
      const result = [];
      for (const model of Array.from<M>(models)) {
        if (!model.isNew()) {
          result.push(model.id);
        }
      }
      return result;
    })();
    const syncOptions = {
      contentType: 'application/json',
      dataType: 'json',
      url: this.url(),
      data: JSON.stringify({ids: modelIds}),
      ...options,
    };
    return this.sync('delete', this, syncOptions).done(() => {
      this.batchModify(() => {
        this.remove(models);
      });
      models.forEach((model) => {
        model.trigger('destroy', model, this, options);
      });
    });
  }

  bulkUpdate(
    updates: Array<Partial<MAttrs>>,
    // latter options are for backbone-extensions
    // TODO: Convert backbone-extensions to TS and make sure prototype overrides propagate
    options?: ModelSaveOptions & {fileUpdate?: boolean}
  ): JQueryPromise<{message: string; updated: Array<MAttrs>}> {
    // eslint-disable-next-line no-restricted-syntax
    return this.sync('update', this, _.extend({attrs: updates}, options)).done(
      ({updated, message}: {updated: Array<MAttrs>; message: string}) => {
        for (const model of Array.from<MAttrs>(updated)) {
          // Type cast is because `parse: true` is not part of `ModelSetOptions`; Backbone is dropping it
          // on the floor.
          this.get(model.id).set(model, {parse: true} as unknown as Backbone.ModelSetOptions);
        }
      }
    );
  }
}

export default BenchlingCollection;
